<template>
  <div class="main-body">
    <promo-bar-test />
    <layout-header />
    <main>
      <nuxt />
    </main>
    <footer-schuette v-if="project === 'schuette'" @cookieSettings="cookieSettings" />
    <footer-rzaska v-if="project === 'rzaska'" @cookieSettings="cookieSettings" />
    <global-layout ref="global" />
  </div>
</template>

<script>
import GlobalLayout from 'marketplace-front-core/components/layout/GlobalLayout'
import LayoutHeader from '~/components/layout/Header'
import FooterSchuette from '~/components/layout/FooterSchuette'
import FooterRzaska from '~/components/layout/FooterRzaska'
import PromoBarTest from '~/components/tests/promo-bar/PromoBarTest'

export default {
  name: 'LayoutDefault',
  components: {
    LayoutHeader,
    FooterSchuette,
    FooterRzaska,
    GlobalLayout,
    PromoBarTest
  },
  computed: {
    isCheckout () {
      return this.$route.name.split('___')[0] === 'checkout'
    }
  },
  methods: {
    cookieSettings () {
      if (this.$refs.global) {
        this.$refs.global.cookieSettingsShowModal()
      }
    }
  }
}
</script>
